import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"

export const getLastDriverLocation = createAsyncThunk(
  "stationsManager/getLastDriverLocation",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_KEY}/DriverLocation/getLastDriverLocation/${params.driverId}/${params.routeId}`,
        {
          headers: {
            Authorization: `Bearer ${params.token}`,
          },
        }
      )
      return data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const getDriverLocationsByRoute = createAsyncThunk(
  "stationsManager/getDriverLocationsByRoute",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_KEY}/DriverLocation/getDriverLocationsByRoute/${params.driverId}/${params.routeId}/${params.sessionId}`,
        {
          headers: {
            Authorization: `Bearer ${params.token}`,
          },
        }
      )
      return data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const stationsManagerPage = createSlice({
  name: "stationsManager",
  initialState: {
    driverLocation: {},
    driverLocationsList: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLastDriverLocation.pending, (state) => {
        state.driverLocation = {}
      })
      .addCase(getLastDriverLocation.fulfilled, (state, { payload }) => {
        state.driverLocation = payload
      })
      .addCase(getLastDriverLocation.rejected, (state, { payload }) => {})

      .addCase(getDriverLocationsByRoute.pending, (state) => {
        state.driverLocationsList = []
      })
      .addCase(getDriverLocationsByRoute.fulfilled, (state, { payload }) => {
        state.driverLocationsList = payload
      })
      .addCase(getDriverLocationsByRoute.rejected, (state, { payload }) => {})
  },
})

export const {} = stationsManagerPage.actions

export default stationsManagerPage.reducer
